import React, { useState } from "react";
import "./Contact.css";
import Footer from "./Footer";

function Contact() {
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		email: "",
		phone: "",
	});
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [errors, setErrors] = useState({});

	// Email validation function
	const isValidEmail = (email) => {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	};

	// Phone formatting function
	const formatPhoneNumber = (value) => {
		if (!value) return value;

		// Remove all non-numeric characters
		const phoneNumber = value.replace(/[^\d]/g, "");

		// Format the number
		if (phoneNumber.length < 4) return phoneNumber;
		if (phoneNumber.length < 7) {
			return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
		}
		return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
			3,
			6
		)}-${phoneNumber.slice(6, 10)}`;
	};

	const handleChange = (e) => {
		const { name, value } = e.target;

		if (name === "phone") {
			// Format phone number as user types
			setFormData((prev) => ({
				...prev,
				[name]: formatPhoneNumber(value),
			}));
		} else if (name === "email") {
			// Clear email error when user starts typing
			setErrors((prev) => ({ ...prev, email: "" }));
			setFormData((prev) => ({
				...prev,
				[name]: value,
			}));
		} else {
			setFormData((prev) => ({
				...prev,
				[name]: value,
			}));
		}
	};

	const validateForm = () => {
		const newErrors = {};

		// Validate email
		if (!isValidEmail(formData.email)) {
			newErrors.email = "Please enter a valid email address";
		}

		// Validate phone (must be 10 digits after removing formatting)
		const phoneDigits = formData.phone.replace(/\D/g, "");
		if (phoneDigits.length !== 10) {
			newErrors.phone = "Please enter a valid 10-digit phone number";
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!validateForm()) {
			return;
		}

		try {
			const response = await fetch("https://formspree.io/f/xlddwlbp", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formData),
			});

			if (response.ok) {
				setIsSubmitted(true);
				setFormData({ firstName: "", lastName: "", email: "", phone: "" });
			} else {
				throw new Error("Failed to send message");
			}
		} catch (error) {
			alert("Failed to send message. Please try again.");
		}
	};

	return (
		<div className="main-container">
			<div className="video-background">
				<video
					autoPlay
					loop
					muted
					playsInline
					ref={(el) => {
						if (el) el.playbackRate = 0.75;
					}}
				>
					<source src="/images/49a01d274a.mp4" type="video/mp4" />
				</video>
			</div>

			<div className="contact-content">
				{!isSubmitted ? (
					<>
						<h1>
							Let's Get <span>Kinected</span>
						</h1>
						<p>
							To kick off our journey together, please fill out the form below
							or send an email. Let's start getting to know each other and
							explore how we can support your family.
						</p>

						<form onSubmit={handleSubmit} className="contact-form">
							<div className="form-row">
								<input
									type="text"
									name="firstName"
									placeholder="First Name"
									value={formData.firstName}
									onChange={handleChange}
									required
								/>
								<input
									type="text"
									name="lastName"
									placeholder="Last Name"
									value={formData.lastName}
									onChange={handleChange}
									required
								/>
							</div>
							<div className="form-row">
								<div className="input-container">
									<input
										type="email"
										name="email"
										placeholder="Email"
										value={formData.email}
										onChange={handleChange}
										required
										className={errors.email ? "error" : ""}
									/>
									{errors.email && (
										<span className="error-message">{errors.email}</span>
									)}
								</div>
								<div className="input-container">
									<input
										type="tel"
										name="phone"
										placeholder="Phone"
										value={formData.phone}
										onChange={handleChange}
										required
										className={errors.phone ? "error" : ""}
									/>
									{errors.phone && (
										<span className="error-message">{errors.phone}</span>
									)}
								</div>
							</div>
							<button type="submit" className="submit-btn">
								SUBMIT
							</button>
						</form>
					</>
				) : (
					<div
						className="thank-you-message"
						style={{
							backgroundImage: `url('/images/submit.jpeg')`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					>
						<h1>Thanks for reaching out!</h1>
						<p>
							We've received your message and will get back to you as soon as
							possible.
						</p>
						<p>Looking forward to getting Kinected!</p>
					</div>
				)}
			</div>

			<Footer />
		</div>
	);
}

export default Contact;
